// src/Components/SubscriptionModal/StepIndicator.jsx
import React from 'react';

const StepIndicator = ({ currentStep, totalSteps = 4 }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  
  return (
    <div className="flex justify-center items-center mb-6 space-x-2">
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${
                step === currentStep
                  ? 'bg-blue-600 text-white scale-110'
                  : step < currentStep
                  ? 'bg-green-500 text-white'
                  : 'bg-gray-600 text-gray-400'
              }`}
            >
              {step < currentStep ? '✓' : step}
            </div>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`w-10 h-0.5 transition-all duration-300 ${
                step < currentStep ? 'bg-green-500' : 'bg-gray-600'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;